import React from 'react';
import cx from 'classnames';
import { Tooltip } from '@trello/nachos/tooltip';
import { forTemplate } from '@trello/i18n';
import { DownIcon } from '@trello/nachos/icons/down';
import { FilterIcon } from '@trello/nachos/icons/filter';
import { MoveIcon } from '@trello/nachos/icons/move';
import styles from './HeaderCellButton.less';
import { TableTestClasses } from '@trello/test-ids';

const format = forTemplate('multi_board_table_view');

interface HeaderCellProps {
  heading: string;
  isClickable?: boolean;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  isActive?: boolean;
  isFilterActive?: boolean;
  isSortingActive?: boolean;
  isSortedDesc?: boolean;
  forwardedRef?: React.Ref<HTMLDivElement>;
  displayHeaderIcons?: boolean;
}

export const HeaderCellButton: React.FunctionComponent<HeaderCellProps> = ({
  heading,
  isClickable,
  isActive,
  onClick,
  forwardedRef,
  isFilterActive,
  isSortingActive,
  isSortedDesc,
}) => {
  return (
    <div
      className={cx(styles.headerCellButton, {
        [styles.clickable]: isClickable,
        [styles.active]: isActive,
      })}
      role="button"
      onClick={isClickable ? onClick : undefined}
      ref={forwardedRef}
    >
      <div
        className={styles.filterIcons}
        data-test-class={
          isFilterActive ? TableTestClasses.HeaderCellFilterActive : null
        }
      >
        <span>{heading}</span>
        {isFilterActive && (
          <Tooltip
            content={format('filter-active')}
            hideTooltipOnMouseDown
            tag="span"
          >
            <span className={styles.circleIconContainer}>
              <FilterIcon dangerous_className={styles.smallerIcon} />
            </span>
          </Tooltip>
        )}
        {isSortingActive && (
          <Tooltip
            content={format('sorting-active')}
            hideTooltipOnMouseDown
            tag="span"
          >
            <span
              className={cx(
                styles.circleIconContainer,
                isSortedDesc ? styles.sortedDesc : styles.sortedAsc,
              )}
            >
              <MoveIcon dangerous_className={styles.smallerIcon} />
            </span>
          </Tooltip>
        )}
      </div>
      {isClickable && (
        <span className={styles.chevron}>
          <DownIcon dangerous_className={styles.smallerIcon} />
        </span>
      )}
    </div>
  );
};
